import SmsPolicyPage from '../components/pages/SmsPolicyPage';
import withTranslate from '../components/withTranslate';

export default withTranslate(SmsPolicyPage);
